import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Col, Row} from "react-bootstrap";
import {loadGeneralEnum} from '../actions/enums';
import {countEvents, loadEvents} from '../actions/events';
import {loadDog} from '../actions/dogs'
import {showModal} from "../actions/modal";
import {resetPage, showMessage} from '../actions';
import {defaultState} from '../reducers/paginate';
import {breadcrumbs} from "../utils";
import Events from "../components/event/Events";

class EventsPage extends Component {

	constructor(props) {
		super(props);

		this.handleFetchData = this.handleFetchData.bind(this);
		this.handleFetchEnums = this.handleFetchEnums.bind(this);
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps) {
	}

	componentWillUnmount() {
		this.props.resetPage();
	}

	handleFetchEnums(enums, filter = {}) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], filter)
			}
		}
	}

	handleFetchData(filter) {
		this.props.loadEvents(filter);
		this.props.countEvents(filter);
	}

	render() {
		const {page, enums, session} = this.props;

		return (
			<div>
				<Row>
					<Col xs={8}>
						{breadcrumbs([{title: 'Příjmy'}])}
					</Col>
				</Row>
				<Events {...page} enums={enums} session={session}
					onLoadDog={this.props.loadDog}
					onFetchEnums={this.handleFetchEnums}
					onFetchData={this.handleFetchData}
				/>
			</div>
		)
	}
}

EventsPage.propTypes = {
	page: PropTypes.object,
	enums: PropTypes.object,
	loadGeneralEnum: PropTypes.func.isRequired,
	loadEvents: PropTypes.func.isRequired,
	countEvents: PropTypes.func.isRequired,
	loadDog: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	resetPage: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired,
	showModal: PropTypes.func.isRequired
};


const mapStateToProps = (state, ownProps) => {
	const {
		pagination: {events},
		enums,
		session
	} = state;

	const page = events[0] || defaultState;

	return {
		page,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadGeneralEnum,
	loadEvents,
	countEvents,
	loadDog,
	showMessage,
	resetPage,
	showModal
})(EventsPage)



// WEBPACK FOOTER //
// ./src/containers/EventsPage.js